module.exports = __webpack_public_path__ + "static/media/poikiliamd_full1.4cdd3071.jpg";